import { assertNever } from "../../../utils/object-utils";
import { FileSort as ApiFileSort, Order as ApiOrder } from '@smile-next/api/lib/drill';
/**
 * 並べ替え項目クラス
 */
var SortCondition = /** @class */ (function () {
    function SortCondition(props) {
        this.sort = props.sort;
        this.order = props.order;
    }
    SortCondition.fromQuery = function (props) {
        return new SortCondition({
            sort: props.sort || defaultSortConditionObject.sort,
            order: props.order || defaultSortConditionObject.order,
        });
    };
    Object.defineProperty(SortCondition.prototype, "toString", {
        get: function () {
            return this.sort + " " + this.order;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortCondition.prototype, "toQueryArray", {
        get: function () {
            return { sortItem: this.sort, sortOrder: this.order };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortCondition.prototype, "toApiWorkSort", {
        get: function () {
            switch (this.sort) {
                case 'name':
                    return ApiFileSort.Name;
                case 'create_datetime':
                    return ApiFileSort.CreateDatetime;
                case 'update_datetime':
                    return ApiFileSort.UpdateDatetime;
                default:
                    return assertNever(this.sort, "\u4E0D\u660E\u306Asort\u304C\u6307\u5B9A\u3055\u308C\u307E\u3057\u305F\u3002: " + this.sort);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortCondition.prototype, "toApiWorkOrder", {
        get: function () {
            switch (this.order) {
                case 'DESC':
                    return ApiOrder.Desc;
                case 'ASC':
                    return ApiOrder.Asc;
                default:
                    return assertNever(this.order, "\u4E0D\u660E\u306Aorder\u304C\u6307\u5B9A\u3055\u308C\u307E\u3057\u305F\u3002: " + this.order);
            }
        },
        enumerable: false,
        configurable: true
    });
    return SortCondition;
}());
export { SortCondition };
export var defaultSortConditionObject = {
    sort: 'update_datetime',
    order: 'DESC',
};
